import { render, staticRenderFns } from "./base-avatar.vue?vue&type=template&id=2c1ff711&"
import script from "./base-avatar.vue?vue&type=script&lang=ts&"
export * from "./base-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./base-avatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports